<template>
    <div>
       <div id="page">
            <Header></Header>
        <div class="tabsw01">
            <div class="item" :class="{active: tabActive === 0}" @click="changeTab(0)">资讯</div>
            <div class="item" :class="{active: tabActive === 1}" @click="changeTab(1)">楼盘</div>
            <div class="item" :class="{active: tabActive === 2}" @click="changeTab(2)">房源</div>
           <div v-if="!isshowlogin" class="item" :class="{active: tabActive === 3}" @click="changeTab(3)">问答</div>
        </div>
        <van-list
                v-show="tabActive === 0"
                v-model="article.loading"
                :finished="article.finished"
                finished-text="没有更多了"
                @load="onLoad('Article')"
        >
            <router-link :to="{path: 'DetailInfoView', query: {id: item.info_id}}" class="listw02-item" v-for="(item, index) in article.list" :key="index">
                <div class="listw02-item-pic"><img :src="item.thumbnail" alt=""></div>
                <div class="listw02-item-txt">
                    <div class="listw02-item-name">{{ item.title }}</div>
                    <div class="listw02-item-info"><span>{{ item.author }}</span><span>{{ item.create_time }}</span></div>
                    <div class="listw02-item-desc">{{ item.description }}</div>
                </div>
            </router-link>
        </van-list>
        <van-list
                v-show="tabActive === 1"
                v-model="building.loading"
                :finished="building.finished"
                finished-text="没有更多了"
                @load="onLoad('Building')"
        >
            <div class="listw01-item" v-for="item in building.list">
                <div class="listw01-item-pic">
                    <router-link :to="{path: 'Property', query: {id: item.building_id}}">
                        <img :src="item.main_img" alt="">
                    </router-link>
                </div>
                <div class="listw01-item-txt">
                    <router-link :to="{path: 'Property', query: {id: item.building_id}}">
                        <div class="listw01-item-name">{{ item.building_name }}</div>
                        <div class="listw01-item-info"><div class="lab">地址：</div><div class="val">{{ item.address }}</div></div>
                        <div class="listw01-item-info"><div class="lab">面积：</div><div class="val">{{ item.building_area }}㎡</div></div>
                        <div class="listw01-item-price">{{ item.rent_sale_price }}</div>
                    </router-link>
                    <div class="listw01-item-tags"><span v-for="sub in item.labels"><router-link :to="{path: 'searchResult', query: {key: sub.label}}">{{ sub.label }}</router-link></span></div>
                    <a class="listw01-item-tel" :href="'tel:'+item.contact_mobile"></a>
                </div>
            </div>
        </van-list>
        <van-list
                v-show="tabActive === 2"
                v-model="house.loading"
                :finished="house.finished"
                finished-text="没有更多了"
                @load="onLoad('House')"
        >
            <div class="listw01-item" v-for="item in house.list">
                <div class="listw01-item-pic"><img :src="item.main_img" alt=""></div>
                <div class="listw01-item-txt">
                    <router-link :to="{path: 'house', query: {id: item.house_id}}">
                        <div class="listw01-item-name">{{ item.house_name }}</div>
                        <div class="listw01-item-info"><div class="lab">地址：</div><div class="val">{{ item.address }}</div></div>
                        <div class="listw01-item-info"><div class="lab">面积：</div><div class="val">{{ item.area }}㎡</div></div>
                        <div class="listw01-item-price">{{ item.rent_sale_price }}</div>
                    </router-link>
                    <div class="listw01-item-tags"><span v-for="sub in item.labels"><router-link :to="{path: 'searchResult', query: {key: sub.label}}">{{ sub.label }}</router-link></span></div>
                    <a class="listw01-item-tel" :href="'tel:'+item.contact_mobile"></a>
                </div>
            </div>
        </van-list>
        <van-list
                v-show="tabActive === 3"
                v-model="question.loading"
                :finished="question.finished"
                finished-text="没有更多了"
                @load="onLoad('Question')"
        >
            <router-link :to="{path: 'questionDetail', query: {sn: item.sn}}" class="listw03-item" v-for="item in question.list">
                <div class="listw03-item-name">{{ item.title }}</div>
                <div class="listw03-item-info">
                    <span class="msg">{{ item.number }}条回答</span>
                    <span class="keep">收藏</span>
                    <span class="share">分享</span>
                    <span class="date">{{ item.re_close_time }}</span>
                </div>
            </router-link>
        </van-list>
       </div>
        <Footer></Footer>
    </div>
</template>

<script>

    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import {List} from 'vant'

    export default {
        name: "UserCollection",
        data(){
            return {
				isshowlogin:false,
                tabActive: 0,
                article: {
                    page: 1,
                    loading: false,
                    finished: false,
                    list: []
                },
                building: {
                    page: 1,
                    loading: false,
                    finished: false,
                    list: []
                },
                house: {
                    page: 1,
                    loading: false,
                    finished: false,
                    list: []
                },
                question: {
                    page: 1,
                    loading: false,
                    finished: false,
                    list: []
                }
            }
        },
        components: {
            Header, Footer,
            [List.name]: List
        },
        mounted() {
            this.getcollectionArticle();
            this.getcollectionBuilding();
            this.getcollectionHouse();
            this.getcollectionQuestion();
			this.isshowlogin=swan.webView.getEnv().smartprogram
        },
        methods: {
            getcollectionArticle(){
                const _this = this;
                _this.api.getcollectionArticle({
                    page: _this.article.page,
                    pageSize: 20
                }).then(function(response){
                    _this.article.page++;
                    _this.article.loading = false;
                    if (response.info_list.length < 20) {
                        _this.article.finished = true
                    }
                    if (_this.article.list.length == 0) {
                        _this.article.list = response.info_list;
                    } else if (_this.article.list[_this.article.list.length - 1].info_id != response.info_list[response.info_list.length - 1].info_id) {
                        _this.article.list = _this.article.list.concat(response.info_list)
                    }
                })
            },
            getcollectionBuilding(){
                const _this = this;
                _this.api.getcollectionBuilding({
                    page: _this.building.page,
                    pageSize: 20
                }).then(function(response){
                    _this.building.page++;
                    _this.building.loading = false;
                    if (response.building_list.length < 20) {
                        _this.building.finished = true
                    }
                    if (_this.building.list.length == 0) {
                        _this.building.list = response.building_list
                    } else if (_this.building.list[_this.building.list.length - 1].building_id != response.building_list[response.building_list.length - 1].building_id) {
                        _this.building.list = _this.building.list.concat(response.building_list)
                    }
                })
            },
            getcollectionHouse(){
                const _this = this;
                _this.api.getcollectionHouse({
                    page: _this.house.page,
                    pageSize: 20
                }).then(function(response){
                    _this.house.page++;
                    _this.house.loading = false;
                    if (response.house_list.length < 20) {
                        _this.house.finished = true
                    }
                    if (_this.house.list.length == 0) {
                        _this.house.list = response.house_list
                    } else if (_this.house.list[_this.house.list.length - 1].house_id != response.house_list[response.house_list.length - 1].house_id) {
                        _this.house.list = _this.house.list.concat(response.house_list)
                    }
                })
            },
            getcollectionQuestion(){
                const _this = this;
                _this.api.getcollectionQuestion({
                    page: _this.question.page,
                    pageSize: 20
                }).then(function(response){
                    _this.question.loading = false;
                    _this.question.page++;
                    if (response.question_list.length < 20) {
                        _this.question.finished = true
                    }
                    if (_this.question.list.length == 0) {
                        _this.question.list = _this.question.list.concat(response.question_list)
                    } else if (_this.question.list[_this.list.length-1].question_id != response.question_list[response.question_list.length-1].question_id) {
                        _this.question.list = _this.question.list.concat(response.question_list)
                    }
                })
            },
            changeTab(index){
                this.tabActive = index;
            },
            onLoad(fnName){
                setTimeout(()=>{
                    this['getcollection'+fnName].apply(this)
                }, 500)
            }
        }
    }
</script>

<style scoped>
    /deep/ .listw02-item-name {white-space: nowrap;overflow: hidden;text-overflow: ellipsis;display: block;-webkit-box-orient: initial;-webkit-line-clamp: initial}
    /deep/ .listw02-item-info {font-size: .2rem;margin-bottom: .1rem;}
    /deep/ .listw02-item-desc {font-size: .24rem;color: #666;-webkit-line-clamp: 2;display: -webkit-box;-webkit-box-orient: vertical;overflow: hidden;}
    /deep/ .tabsw01 {margin-bottom: .2rem;}
    /deep/ .van-list {min-height: calc(100vh - 3.84rem);}
</style>